export const itemDetailValue = (value) => {
  let val = "-";
  if ( value !== undefined &&  value !== "") {
    val = value;
  }
  return val;
};
